import gql from 'graphql-tag'

export const SKILL_TAGS = gql`
  query getSkills($locale: String = "en") {
    skills(first: 5000) {
      data {
        globalId
        name(locale: $locale)
      }
    }
  }
`

export const INDUSTRY_TAGS = gql`
  query getIndustries($locale: String = "en") {
    industries(first: 1000) {
      data {
        globalId
        name(locale: $locale)
      }
    }
  }
`
